import React from "react";
import Calendar from "react-calendar";
import makeStyles from '@mui/styles/makeStyles';
import "react-calendar/dist/Calendar.css";
import {
  ArrowBackIosOutlined,
  ArrowForwardIosOutlined,
  PublicOutlined
} from "@mui/icons-material";
import moment from "moment";
import { convertTo12HourFormat } from 'src/config/Utils';
import { SideInfo } from '../AppointmentBook';

const useStyles = makeStyles(theme => ({
    calendarRoot:props=> ({
        fontFamily: "'Oswald', sans-serif !important",
        borderRadius: "10px",
        border: "none !important",
        margin: 'auto',
        "& .react-calendar__month-view__weekdays__weekday": {
        fontSize: "12px",
        fontWeight: 400,

        "& abbr": {
            textDecoration: "none",
        },
    },

    "& .react-calendar__tile": {
        width: "calc(100%/7)",
        height: "50px",
        backgroundColor: "#fff",
        border: "1px solid transparent",
        borderRadius: "50%",
        color: "rgba(26,26,26,0.61)",
        fontSize: "15px",
        padding: "1px 0 0",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        flex: "unset !important",
        "&:disabled": {
            backgroundColor: "#fff",
            color: "#d5dce0",
            cursor: "not-allowed",
        },
        "&:enabled": {
            "&:hover": {
              backgroundColor: props.calendarBg ? `${props.calendarBg} !important` : "rgba(0,105,255,0.065) !important",
              color: props.calendarColor ? `${props.calendarColor} !important` : "#0060e6 !important",
              fontWeight: 700,
            },

            "&:focus": {
              backgroundColor: props.calendarBg ? `${props.calendarBg} !important` : "rgba(0,105,255,0.065) !important",
              color: props.calendarColor ? `${props.calendarColor} !important` : "#0060e6 !important",
              fontWeight: 700,
            },
        },
    },

    "& .react-calendar__tile--active": {
        backgroundColor: props.calendarBg ? `${props.calendarBg} !important` : "rgba(0,105,255,0.065) !important",
        color: props.calendarColor ? `${props.calendarColor} !important` : "#0060e6 !important",
        fontWeight: 700,
    },

    "& .react-calendar__navigation": {
        "& button:nth-child(1)": {
            visibility: "hidden",
        },
        "& button:nth-child(5)": {
            visibility: "hidden",
        },

        "& button:nth-child(3)": {
            backgroundColor: "#fff",
            pointerEvents: "none",
            "&:hover": {
            backgroundColor: "#fff !important",
        },
    },

    "& button:nth-child(even)": {
        backgroundColor: props.calendarBgHover ? props.calendarBgHover : "rgba(0,105,255,0.065)",
        width: "38px",
        height: "38px",
        borderRadius: "50%",
        color: props.calendarBg ? props.calendarBg : "rgb(0,105,255)",
        minWidth: "38px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:hover": {
            backgroundColor: props.calendarBgHover ? `${props.calendarBgHover} !important` : "rgba(0,105,255,0.15) !important",
        },
      },
    },
  }),

  timeslotDiv:{
    maxHeight:'450px',
    overflow:'scroll'
  },

  arrowBtn:props=> ({
    backgroundColor: props.calendarBgHover ? props.calendarBgHover : "rgba(0,105,255,0.065)",
    width: "38px",
    height: "38px",
    color: "rgb(0,105,255)",
    borderRadius: "50%",
  }),

    flexDiv: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
    },

    btnDiv: {
      width:'350px',
      margin:'10px auto',
      [theme.breakpoints.down('sm')]: {
        width:'100%'
      }
    },

    btn: props=> ({
        width: "100%",
        height: "52px",
        border: `1px solid ${props.calendarBg ? props.calendarBg : 'rgba(0,105,255,0.5)'}`,
        color: props.calendarBg || "rgb(0,105,255)",
        position: "relative",
        verticalAlign: "top",
        padding: "13px 10px",
        borderRadius: "4px",
        fontWeight: 700,
        backgroundColor: "transparent",
        transition: "all .3s ease",
        transitionProperty: "width,transform",
        fontSize:'16px',
        cursor:'pointer',
        '&:hover':{
          border: `2px solid ${props.calendarBg ? props.calendarBg : 'rgba(0,105,255,0.5)'}`
        }
    }),

    btnWid: {
        width: "48.5% !important",
    },

    btnSelected: {
        borderColor: "transparent !important",
        backgroundColor: "rgb(0 0 0/60%) !important",
        color: "rgba(255,255,255,1) !important",
        '&:hover':{
          border: 'none !important'
        }
    },

    confirmBtn: props=>({
        backgroundColor: props.calendarBg || "rgb(0,105,255)",
        color: "#ffffff",
        boxShadow: "0 1px 6px 0 rgb(0 0 0/10%)"
    }),

    colDiv:{
      display:'flex',
      flexDirection:'column',
      overflow:'auto'
    },

    noSlot:{
      padding: '16px',
      backgroundColor: '#f6f8f9',
      fontSize: '14px',
      textAlign: 'center',
      margin:'10px auto',

      '& p':{
        fontWeight: 700,
        fontSize: '16px'
      }
    },

    headSpan:{
      fontSize:'16px',
      fontWeight: 'bold',
      padding:'0px 20px',
      [theme.breakpoints.down('sm')]: {
          fontSize:'13px'            
      }
    },

    timezoneCls:{
      color:'#000 !important',
      fontSize:'15px !important',
      fontWeight:'normal !important',
    }
  }));

function Calendars(props) {
  const { schedule, selectedDate, selectDateEvent, showCalendar, showTime, selectedTime, selectTimeEvent, timeSlots, confirmEvent, t, fontFamily, timeslotloading, userTimezone, marginClass,
  calendarBg,calendarColor, calendarBgHover, data } = props || {};
  const classes = useStyles({calendarBg,calendarColor,calendarBgHover});
  const { isRTL } = data || {};

  if(schedule)
  return (
    <>
        {showCalendar ?
        <Calendar
            onChange={(value, event) => selectDateEvent(value)}
            value={selectedDate}
            tileDisabled={({ date }) =>
            disableDay(schedule["weeklyHours"]).includes(date.getDay())
            }
            {...(!schedule["forever"]
            ? {
                maxDate: schedule.availabilityDateRange?.["end"] ? new Date(
                    dateToString(schedule.availabilityDateRange?.["end"])
                ) : '',
                minDate: schedule.availabilityDateRange?.["start"] ? new Date(
                    dateToString(schedule.availabilityDateRange?.["start"])
                ) : '',
                ...(schedule.availabilityDateRange?.["start"] ? {defaultActiveStartDate: new Date(dateToString(schedule.availabilityDateRange?.["start"]))} : {})
              }
            : {
              defaultActiveStartDate: new Date(),
              minDate: new Date()
            }
            )}
            
            calendarType={schedule.calendarType || 'hebrew'}
            className={`${classes.calendarRoot}`}
            nextLabel={isRTL === 'ar' ? <ArrowBackIosOutlined /> : <ArrowForwardIosOutlined />}
            prevLabel={isRTL === 'ar' ? <ArrowForwardIosOutlined /> : <ArrowBackIosOutlined />}
        />
        :
        null}

        <p className={classes.headSpan} style={{fontFamily:'inherit'}}>{t && t('services.sh-section.timezone')}</p>
        <SideInfo 
            {...{
                icon: <PublicOutlined className={`${marginClass}`} style={{color:'#000'}}/>,
                text: userTimezone || '---',
                fontFamily:'inherit',
                titleCustomCls: classes.timezoneCls,
            }}
        />

        {showTime && !timeslotloading ? 
        <div className={`${classes.colDiv}`}>
          {selectedDate && showTime ? <span style={{fontFamily:'inherit',margin:'10px auto',fontSize:'19px',fontWeight:500}}>{moment(new Date(selectedDate)).format('dddd, MMMM D')}</span> : null}
          <div className={`${classes.colDiv} ${classes.timeslotDiv}`}>
          {timeSlots?.length ? React.Children.toArray(timeSlots.map(v=> {
            return (
              <div className={`${classes.btnDiv} ${classes.flexDiv} ${classes.wid350}`}>
                <button
                className={`${classes.btn} ${selectedTime === v?.['time'] ? `${classes.btnWid} ${classes.btnSelected}` : ''}`}
                onClick={()=> selectTimeEvent(v?.['time'],v?.['partnerTime'])}
                >
                {convertTo12HourFormat(v?.['time'])}
                </button>

                {selectedTime === v?.['time'] ?
                <button
                  className={`${classes.btn} ${selectedTime === v?.['time'] ? classes.btnWid : ''} ${classes.confirmBtn}`}
                  onClick={confirmEvent}
                  style={{fontFamily:'inherit'}}
                >
                {t && t('services.sh-section.confirm')}
                </button>
                : null}
              </div>
            )
          }))
          :
          <div className={classes.noSlot}>
            <p style={{fontFamily:'inherit'}}>{t && t('services.sh-section.noTimeSlot',{date: moment(new Date(selectedDate)).format('MMMM D')})}</p>
            <span style={{fontFamily:'inherit',fontSize:'16px'}}>{t && t('services.sh-section.noTimeSlot2')}</span>
          </div>
          }
          </div>
        </div>
        :
        null}
    </>
  );

  return null;
}

function disableDay(weeklyHours) {
  return weeklyHours ? weeklyHours.filter((v) => !v.selected).map((val) => val.day): [];
};
export function dateToString(date) {
  var _date = new Date(date * 1000);

  return new Date(_date.getFullYear(), _date.getMonth(), _date.getDate());
};

export default Calendars;